import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

class DisableableButton extends React.Component {
  buttonText() {
    if (this.props.disabled) {
      return this.props.disabledText;
    }
    return this.props.enabledText;
  }

  buttonClasses() {
    return classNames(this.props.buttonClasses, { [this.props.disabled]: 'disabled' });
  }

  render() {
    return (
      <button
        type="button"
        className={this.buttonClasses()}
        disabled={this.props.disabled}
        id={this.props.id}
        onClick={this.props.handleClick}
      >
        {this.buttonText()}
      </button>
    );
  }
}

DisableableButton.propTypes = {
  id: PropTypes.string,
  buttonClasses: PropTypes.string.isRequired,
  disabledText: PropTypes.string.isRequired,
  enabledText: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default DisableableButton;
